// extracted by mini-css-extract-plugin
export default {"btnHolder":"EmploymentDetails_btnHolder__5bZCW","occupation":"EmploymentDetails_occupation__wlZfY","modalView":"EmploymentDetails_modalView__gnt3s"};